module.exports = __webpack_public_path__ + "static/cam-aleon-0513030561276f1eddcefb97f130bb4b.mp4";